import React, { useEffect, useState } from "react";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import { Modal } from "react-bootstrap";
import moment from "moment";

export function AdminGeneral() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    try {
      setLoader(true);
      const res = await api.getFreePostByAdmin({ page });
      setData(res.trades || []);
      setTotal(res.total || 0);
      setLimit(res.limit || 10);
      setLoader(false);
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this post?",
    );
    if (!confirmed) return;
    try {
      setLoader(true);
      await api.deleteFreePost({ id });
      getPosts();
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      <div className="container-fluid modern-admin-container">
        <div className="modern-page-header">
          <div className="header-content">
            <div className="title-container">
              <h1 className="modern-page-title">General Updates</h1>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="stats-container">
          <div className="col-lg-4">
            <div className="stat-card">
              <div className="stat-icon total">
                <i className="fas fa-newspaper"></i>
              </div>
              <div className="stat-content">
                <span className="stat-value">{total}</span>
                <span className="label-stat">Total Updates</span>
              </div>
              <div className="stat-trend">
                <i className="fas fa-chart-line"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="modern-content-card">
          <div className="card-header-section">
            <div className="table-actions">
              <div className="table-info">
                <span className="info-text">
                  Showing {data.length} of {total} updates
                </span>
              </div>
            </div>
          </div>

          <div className="table-responsive-container">
            <GeneralTable
              data={data}
              page={page}
              setPage={setPage}
              total={total}
              limit={limit}
              deletePost={deletePost}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const GeneralTable = ({ data, page, setPage, total, limit, deletePost }) => {
  const [imgModal, setImgModal] = useState({ show: false, src: "" });

  const handleChange = (event, value) => setPage(value);

  const formatDate = (date) => moment(date).format("MMM Do YYYY, h:mm a");

  const formatVal = (value) => {
    if (value === undefined || value === null) return "-";
    const dec = value.toString().split(".")[1];
    return dec && dec.length > 4 ? Number(value.toFixed(4)) : value;
  };

  return (
    <>
      <table className="modern-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Video</th>
            <th>Voice</th>
            <th>Description</th>
            {/* <th>Coin</th> */}
            {/* <th>Position</th> */}
            {/* <th>Entry Price</th> */}
            {/* <th>Take Profit</th> */}
            {/* <th>Stop Loss</th> */}
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, idx) => (
              <tr key={idx}>
                <td>
                  {item?.image ? (
                    <img
                      src={item.image}
                      alt="img"
                      onClick={() =>
                        setImgModal({ show: true, src: item.image })
                      }
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>
                <td>
                  {item?.video ? (
                    <video controls style={{ width: 200 }}>
                      <source src={item.video} />
                    </video>
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>
                <td>
                  {item?.voice ? (
                    <audio controls style={{ width: 200 }}>
                      <source
                        src={`${process.env.REACT_APP_S3URLVoice}/${item.voice}`}
                      />
                    </audio>
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>
                <td>
                  <div className="description-cell">
                    {item?.description ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      />
                    ) : (
                      <span className="empty-cell">-</span>
                    )}
                  </div>
                </td>
                {/* <td>
                  <div className="date-cell">{item?.coin || "-"}</div>
                </td>
                <td>
                  <div className="date-cell">{item?.position || "-"}</div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.entryPrice ? "$" + formatVal(item.entryPrice) : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.targetPrice
                      ? "$" + formatVal(item.targetPrice)
                      : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.stopLoss ? "$" + formatVal(item.stopLoss) : "-"}
                  </div>
                </td> */}
                <td>
                  <div className="date-cell">
                    {item?.createdAt ? formatDate(item.createdAt) : "-"}
                  </div>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deletePost(item._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12">
                <div className="empty-state">
                  <div className="empty-icon">
                    <i className="fas fa-newspaper"></i>
                  </div>
                  <h3 className="empty-title">No Data Found</h3>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {total > 0 && (
        <div className="pagination-container">
          <div className="d-flex justify-content-center py-4">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(total / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
                shape="rounded"
                size="medium"
              />
            </Stack>
          </div>
        </div>
      )}

      <Modal
        show={imgModal.show}
        onHide={() => setImgModal({ show: false, src: "" })}
        centered
        size="lg"
      >
        <Modal.Header closeButton />
        <Modal.Body className="p-0 text-center">
          <img
            src={imgModal.src}
            alt="preview"
            style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
